import { CreateHeaderActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/header'
import { Issue } from '../IssueTrackerContext/types'
import { useIssueTrackerContext } from '../IssueTrackerContext'
import { Permission } from '@cims-online/shared'

export function useCreate(): CreateHeaderActionOptions<Issue> | undefined {
  const {
    relations,
    draftSubmitModal: { toggle },
    payItemGlobalId,
  } = useIssueTrackerContext()
  if (!!payItemGlobalId) return undefined
  return {
    loading: relations.loading,
    entity: 'Issue',
    permission: Permission.CreateIssue,
    modal: { type: 'custom', toggle },
  }
}
